// (NB! GENERATED FILE) DO NOT EDIT! 
export const SpriteDefResourceUri = "/generated/9c3c02d280768047.json.z";
